import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"video_request",
    list_id:"video_request_frame_list",
    x_column_list_arr:[
      {"key":"a_writer","name":"요청자","width":"100","is_show":"1"},
      {"key":"a_is_agree","name":"승인상태","width":"100","is_show":"1"},
      {"key":"a_date","name":"신청일","width":"100","is_show":"1"},
      {"key":"a_create_date","name":"작성시간","width":"160","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':10,
      'order_id':'a_stu_name',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_corse_seq","a_stu_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;